// REACT IMPORTS
import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../../AppContextProvider";
import FeedbackJsonStorage from "../../utils/feedback/feedbackJsonStorage";
import { AvalancheContext } from "../../avalanche/AvalancheProvider";
import server from "../../assets/media/icons/dashboard-dark.svg";
import file from "../../assets/media/icons/document.svg";
import views from "../../assets/media/icons/magic.svg";
import docu from "../../assets/media/icons/document.svg";
import settings from "../../assets/media/icons/cog-alt.svg";
import tools from "../../assets/media/icons/question-mark-outline.svg";
import server_dark from "../../assets/media/icons/dashboard-dark.svg";
import file_dark from "../../assets/media/icons/list-bullets.svg";
import views_dark from "../../assets/media/icons/magic-dark.svg";
import docu_dark from "../../assets/media/icons/document-dark.svg";
import settings_dark from "../../assets/media/icons/wrench.svg";
import tools_dark from "../../assets/media/icons/question-mark-outline-dark.svg";
import values_dark from "../../assets/media/icons/aggregated-alt2.svg";
import import_dark from "../../assets/media/icons/import.svg";

import server_white from "../../assets/media/icons/dashboard-white.svg";
import file_white from "../../assets/media/icons/list-bullets-white.svg";
import values_white from "../../assets/media/icons/aggregated-alt2-white.svg";
import settings_white from "../../assets/media/icons/wrench-white.svg";
import views_white from "../../assets/media/icons/magic-white.svg";
import import_white from "../../assets/media/icons/import-white.svg";

import { MDBSideNavItem, MDBSideNavLink, MDBBadge } from "mdb-react-ui-kit";
import {
  DASHBOARD_PAGE,
  FILES_PAGE,
  REPORTS_PAGE,
  DOCS_PAGE,
  HELP_PAGE,
  ADMIN_PAGE,
  DATA_IMPORT_PAGE,
  LOGIN_PAGE_URL,
} from "../../data/pages";
import { WalletProviderContext } from "../../walletprovider/WalletProvider";
import { DwMpcWalletBackendProviderContext } from "../../mpcwalletprovider/DwMpcWalletBackendProvider";
import {
  collectLog,
  createEmptyLogsAndVars,
  recordVariable,
  dwReportError,
} from "../../utils/diagnostics/clientErrors";

const SideNavComponent = (props) => {
  const avalancheContext = useContext(AvalancheContext);
  const feedbackJsonStorage = FeedbackJsonStorage.create(avalancheContext);
  const { storageProps } = useContext(DwMpcWalletBackendProviderContext);
  const navigate = useNavigate();
  const context = useContext(AppContext);
  const [isDark, setIsDark] = useState(true);
  const { selectedAccount } = useContext(WalletProviderContext);
  //const [badgeCount, setBadgeCount] = useState(0);

  /*const getAccount = async () => {
    const logsAndVars = createEmptyLogsAndVars("SideNavComponent:getAccount");
    try {
      const res = await feedbackJsonStorage.getAllFeedback();
      collectLog(logsAndVars, "getting all feedbacks from Avalanche is done");
      setBadgeCount(res.filter((k) => k.feedback.isUnread === true).length);
      collectLog(logsAndVars, "setBadgeCount is done");
    } catch (error) {
      dwReportError(selectedAccount, storageProps.portalClientId, error, { logsAndVars });
      console.log(error);
    }
  };*/

  useEffect(() => {
    if (
      document.documentElement.getAttribute("data-color-mode") === "dark" ||
      document.documentElement.getAttribute("data-color-mode") === null
    ) {
      setIsDark(true);
    } else {
      setIsDark(false);
    }
    //getAccount();
  }, [context.getState()?.isRender]);

  return (
    <>
      <MDBSideNavItem
        className="menu-item"
        onClick={() => {
          navigate(DASHBOARD_PAGE.url);
          props.setBasicOpen();
        }}
      >
        <MDBSideNavLink active={window.location.pathname === DASHBOARD_PAGE.url}>
          <img
            className="img"
            alt={DASHBOARD_PAGE.title}
            src={!isDark ? server : window.location.pathname === DASHBOARD_PAGE.url ? server_white : server_dark}
          />
          <div className="side-nav-text">{DASHBOARD_PAGE.title}</div>
        </MDBSideNavLink>
      </MDBSideNavItem>
      <MDBSideNavItem
        className="menu-item"
        onClick={() => {
          navigate(FILES_PAGE.url);
          props.setBasicOpen();
        }}
      >
        <MDBSideNavLink active={window.location.pathname === FILES_PAGE.url}>
          <img
            className="img"
            alt={FILES_PAGE.title}
            src={!isDark ? file : window.location.pathname === FILES_PAGE.url ? file_white : file_dark}
          />
          <div className="side-nav-text">{FILES_PAGE.title}</div>
        </MDBSideNavLink>
      </MDBSideNavItem>

      <MDBSideNavItem
        className="menu-item"
        onClick={() => {
          navigate(DATA_IMPORT_PAGE.url);
          props.setBasicOpen();
        }}
      >
        <MDBSideNavLink active={window.location.pathname === DATA_IMPORT_PAGE.url}>
          <img
            className="img"
            alt={DATA_IMPORT_PAGE.title}
            src={!isDark ? import_dark : window.location.pathname === DATA_IMPORT_PAGE.url ? import_white : import_dark}
          />
          <div className="side-nav-text">{DATA_IMPORT_PAGE.title}</div>
        </MDBSideNavLink>
      </MDBSideNavItem>
      {/*
      <MDBSideNavItem
        className="menu-item"
        onClick={() => {
          navigate(REPORTS_PAGE.url);
          props.setBasicOpen();
        }}
      >
        <MDBSideNavLink active={window.location.pathname === REPORTS_PAGE.url}>
          <img
            className="img"
            alt={REPORTS_PAGE.title}
            src={!isDark ? views_dark : window.location.pathname === REPORTS_PAGE.url ? views_white : views_dark}
          />
          <div className="side-nav-text">{REPORTS_PAGE.title}</div>
        </MDBSideNavLink>
      </MDBSideNavItem>
      */}
      {/*
      <MDBSideNavItem
        className="menu-item"
        onClick={() => {
          //navigate(DASHBOARD_PAGE.url);
          props.setBasicOpen();
        }}
      >
        <MDBSideNavLink active={window.location.pathname === HELP_PAGE.url}>
          <img className="img" alt={HELP_PAGE.title} src={!isDark ? tools : tools_dark} />
          <div className="side-nav-text">{HELP_PAGE.title}</div>
        </MDBSideNavLink>
      </MDBSideNavItem>
    */}
      {/*localStorage.getItem("selectedUserRole") === "admin" && (
        <MDBSideNavItem
          className="menu-item"
          onClick={() => {
            navigate(ADMIN_PAGE.url);
            props.setBasicOpen();
          }}
        >
          <MDBSideNavLink active={window.location.pathname === ADMIN_PAGE.url}>
            <img
              className="img"
              alt={ADMIN_PAGE.title}
              src={!isDark ? settings : window.location.pathname === ADMIN_PAGE.url ? settings_white : settings_dark}
            />
           
            <div className="side-nav-text" style={{ position: "relative" }}>
              {ADMIN_PAGE.title}
              {badgeCount > 0 && (
                <MDBBadge color="danger" className="bg-danger border border-light rounded-circle">
                  {badgeCount}
                </MDBBadge>
              )}
                
            </div>
          </MDBSideNavLink>
        </MDBSideNavItem>
      )*/}
    </>
  );
};

export default SideNavComponent;
